<div *transloco="let t" class="w-1/2">
  @if (strategy(); as strategy) {
    @if (isAwareness()) {
      @if (isStvMedia()) {
        <p class="mb-4 text-sm text-gray-500">{{ t("dsp-supply.introduction") }}</p>
        <div class="flex flex-col gap-4">
          <div class="flex flex-col gap-4 rounded-md border border-gray-300 p-4">
            <div class="flex w-full items-center justify-between">
              <div class="text-sm font-bold">{{ t("common.amz_supply") }}</div>
              <IToggle
                [disabled]="isReadOnly()"
                [checked]="isSupplyEnabled(SupplyType.AMZ_TWITCH_STV)"
                [loading]="updatingSupplyFlags.amzTwitchStvSupply()"
                (checkedChange)="toggleSupply('amzTwitchStvSupply')"
              />
            </div>
          </div>
          <div class="flex flex-col gap-4 rounded-md border border-gray-300 p-4">
            <div class="flex w-full items-center justify-between">
              <div class="text-sm font-bold">{{ t("common.tpe_supply") }}</div>
              <IToggle
                [disabled]="isReadOnly()"
                [checked]="isSupplyEnabled(SupplyType.TPE_STV)"
                [loading]="updatingSupplyFlags.tpeStvSupply()"
                (checkedChange)="toggleSupply('tpeStvSupply')"
              />
            </div>
          </div>
        </div>
      } @else if (isVideoDealMedia()) {
        <p class="mb-4 text-sm text-gray-500">{{ t("dsp-media-selector.video_deal_deals_intro") }}</p>
        <app-dsp-deal-selector
          [disabled]="isReadOnly() || !!guaranteedDeal()"
          [deals]="offeredDeals()"
          [dealId]="strategyDealIds()[0]"
          (dealIdChange)="onDealChange($event)"
        />
      }
    } @else {
      <p class="mb-4 text-sm text-gray-500">{{ t("dsp-supply.introduction") }}</p>
      <div class="flex flex-col gap-4">
        <div class="flex flex-col gap-4 rounded-md border border-gray-300 p-4">
          <div class="text-sm font-bold">
            {{ t("common.amz_supply") }}
          </div>
          <div class="flex w-full items-center justify-between">
            <div class="text-sm">
              {{ t("common.amz_website_apps_supply", { amazonDomain: amazonDomain() | titlecase }) }}
            </div>
            <IToggle
              [disabled]="isReadOnly()"
              [checked]="isSupplyEnabled(SupplyType.AMZ)"
              [loading]="updatingSupplyFlags.amzSupply()"
              (checkedChange)="toggleSupply('amzSupply')"
            />
          </div>
          <div class="flex w-full items-center justify-between">
            <div class="text-sm">
              {{ t("common.amz_alexa_supply") }}
            </div>
            <IToggle
              [disabled]="isReadOnly()"
              [checked]="isSupplyEnabled(SupplyType.AMZ_ALEXA)"
              [loading]="updatingSupplyFlags.amzAlexaSupply()"
              (checkedChange)="toggleSupply('amzAlexaSupply')"
            />
          </div>
          <div class="flex w-full items-center justify-between">
            <div class="text-sm">
              {{ t("common.amz_twitch_supply") }}
            </div>
            <IToggle
              [disabled]="isReadOnly()"
              [loading]="updatingSupplyFlags.amzTwitchSupply()"
              [checked]="isSupplyEnabled(SupplyType.AMZ_TWITCH)"
              (checkedChange)="toggleSupply('amzTwitchSupply')"
            />
          </div>
          <div class="flex w-full items-center justify-between">
            <div class="text-sm">
              {{ t("common.amz_imdb_supply") }}
            </div>
            <IToggle
              [disabled]="isReadOnly()"
              [loading]="updatingSupplyFlags.amzImdbSupply()"
              [checked]="isSupplyEnabled(SupplyType.AMZ_IMDB)"
              (checkedChange)="toggleSupply('amzImdbSupply')"
            />
          </div>
        </div>
        <div class="flex flex-col gap-4 rounded-md border border-gray-300 p-4">
          <div class="flex w-full items-center justify-between">
            <div class="text-sm font-bold">
              {{ t("common.apd_supply") }}
            </div>
            <IToggle
              [disabled]="isReadOnly()"
              [checked]="isSupplyEnabled(SupplyType.APD)"
              [loading]="updatingSupplyFlags.apdSupply()"
              (checkedChange)="toggleSupply('apdSupply')"
            />
          </div>
        </div>
        <div class="flex flex-col gap-4 rounded-md border border-gray-300 p-4">
          <div class="flex w-full items-center justify-between">
            <div class="text-sm font-bold">
              {{ t("common.tpe_supply") }}
            </div>
            <IToggle
              [disabled]="isReadOnly()"
              [checked]="isSupplyEnabled(SupplyType.TPE)"
              [loading]="updatingSupplyFlags.tpeSupply()"
              (checkedChange)="toggleSupply('tpeSupply')"
            />
          </div>
        </div>
      </div>
    }

    <div class="mt-4 flex flex-col gap-2 rounded-md border p-4">
      <div class="type-body-medium">{{ t("page-title.dsp_inventory_blacklist") }}</div>
      <p class="type-body text-muted-foreground">{{ t("dsp-supply.exclusion_scope") }}</p>
      <a
        iButton
        variant="secondary"
        size="sm"
        class="self-start"
        [routerLink]="exclusionPageUrl"
        queryParamsHandling="merge"
      >
        {{ t("dsp-supply.open_exclusion_page") }}
      </a>
    </div>
  }
</div>
